import { lazyLoad } from "./helpers";

const UserList = lazyLoad("Users/UserList");
const UserCreateEdit = lazyLoad("Users/UserCreateEdit");
const StudentsList = lazyLoad("Users/StudentsList");
const MoveStudents = lazyLoad("Users/MoveStudents");
const UserPermissions = lazyLoad("Users/UserPermissions");  

const UserRequestList = lazyLoad("Users/UserRequestList");
const DepartmentList = lazyLoad("HRMS/Departments/DepartmentList"); 
const DepartmentCreateEdit = lazyLoad("HRMS/Departments/DepartmentCreateEdit");
const DesignationList = lazyLoad("HRMS/Designations/DesignationList");
const DesignationCreateEdit = lazyLoad("HRMS/Designations/DesignationCreateEdit");

const ProjectList = lazyLoad("Projects/ProjectList");
const ProjectCreateEdit = lazyLoad("Projects/ProjectCreateEdit");
const InstituteList = lazyLoad("Institutes/InstituteList");
const InstituteCreateEdit = lazyLoad("Institutes/InstituteCreateEdit");
const LeadConvertToCustomer = lazyLoad("Institutes/LeadConvertToCustomer");

const TrainingList = lazyLoad("Trainings/TrainingList");
const TrainingCreateEdit = lazyLoad("Trainings/TrainingCreateEdit");
const ScheduleList = lazyLoad("Schedules/ScheduleList");
const ScheduleCreateEdit = lazyLoad("Schedules/ScheduleCreateEdit");

const TypeOfReports = lazyLoad("Reports/TypeOfReports");
const CrossDateExport = lazyLoad("Reports/CrossDateExport");
const TrainerAttendance = lazyLoad("Reports/TrainerAttendance");
const TrainerAttendanceSummary = lazyLoad("Reports/TrainerAttendanceSummary");
const StudentAttendance = lazyLoad("Reports/StudentAttendance");
const StudentsDetails = lazyLoad("Reports/StudentsDetails");
const Student = lazyLoad("Reports/Student");
const AssessmentReport = lazyLoad("Reports/AssessmentReport");
const DailyTrainingDocuments = lazyLoad("Reports/DailyTrainingDocuments");
const TrainingSummary = lazyLoad("Reports/TrainingSummary");
const TrainingOverviewReport = lazyLoad("Reports/TrainingOverviewReport");
const FeedbackReport = lazyLoad("Reports/FeedbackReport");
const InstituteOverview = lazyLoad("Reports/InstituteOverview");

const Repository = lazyLoad("Tools/Repository");
const RepositoryList = lazyLoad("Tools/Repository/RepositoryList");
const RepositoryCreateEdit = lazyLoad("Tools/Repository/RepositoryCreateEdit");
const AttendanceList = lazyLoad("Tools/AttendanceTools/AttendanceList");

const TypeOfTools = lazyLoad("Tools/TypeOfTools");
const Notes = lazyLoad("Tools/Notes");
const NoteList = lazyLoad("Tools/Notes/NoteList");

const SalesList = lazyLoad("SalesActivities/List");
const SalesCreateEdit = lazyLoad("SalesActivities/CreateEdit");
const SalesFullTimeline = lazyLoad("SalesTimeline/SalesFullTimeline");

const SalesScheduleList = lazyLoad("SalesSchedules/ScheduleList");
const SalesScheduleCreateEdit = lazyLoad("SalesSchedules/CreateEdit");

const EmployeeProfileCreateEdit = lazyLoad("HRMS/Employee/EmployeeProfileCreateEdit");

const LeavesSubmenu = lazyLoad("HRMS/Leaves/LeavesSubmenu");
const LeaveTypeList = lazyLoad("HRMS/Leaves/LeaveType/LeaveTypeList");
const LeaveTypeCreateEdit = lazyLoad("HRMS/Leaves/LeaveType/LeaveTypeCreateEdit");
const LeavePolicySetList = lazyLoad("HRMS/Leaves/LeavePolicySet/LeavePolicySetList");
const LeavePolicySetCreateEdit = lazyLoad("HRMS/Leaves/LeavePolicySet/LeavePolicySetCreateEdit");
const LeavePolicySetDetailList = lazyLoad("HRMS/Leaves/LeavePolicySetDetail/LeavePolicySetDetailList");
const LeavePolicySetDetailCreateEdit = lazyLoad("HRMS/Leaves/LeavePolicySetDetail/LeavePolicySetDetailCreateEdit");
const HolidayList = lazyLoad("HRMS/Leaves/Holiday/HolidayList");
const HolidayCreate = lazyLoad("HRMS/Leaves/Holiday/HolidayCreate");

const HRToolsSubmenu = lazyLoad("HRMS/HRTools/HRToolsSubmenu");

const DocumentsSubmenu = lazyLoad("HRMS/Documents/DocumentsSubmenu");
const DocumentList = lazyLoad("HRMS/Documents/DocumentList");
const WorkCalendarList = lazyLoad("HRMS/HRTools/WorkCalendar/WorkCalendarList");
const WorkCalendarCreateEdit = lazyLoad("HRMS/HRTools/WorkCalendar/WorkCalendarCreateEdit");
const ShiftTemplateList = lazyLoad("HRMS/HRTools/Shifts/ShiftTemplateList");
const ShiftTemplateCreateEdit = lazyLoad("HRMS/HRTools/Shifts/ShiftTemplateCreateEdit");
const EmployerBankAccountList = lazyLoad("HRMS/HRTools/EmployerBankAccounts/EmployerBankAccountList");
const EmployerBankAccountCreateEdit = lazyLoad("HRMS/HRTools/EmployerBankAccounts/EmployerBankAccountCreateEdit");
const AssignedPolicyList = lazyLoad("HRMS/HRTools/AssignPolicy/AssignedPolicyList");
const AssignedPolicyCreateEdit = lazyLoad("HRMS/HRTools/AssignPolicy/AssignedPolicyCreateEdit");
const PolicyDocumentList = lazyLoad("HRMS/HRTools/PolicyDocuments/PolicyDocumentList");
const PolicyDocumentCreateEdit = lazyLoad("HRMS/HRTools/PolicyDocuments/PolicyDocumentCreateEdit");
const LeaveLedgerList = lazyLoad("HRMS/Leaves/Adjustment/LeaveLedgerList");

const AdjustmentCreate = lazyLoad("HRMS/Leaves/Adjustment/AdjustmentCreate");

const AttendanceSubmenu = lazyLoad("HRMS/Attendance/AttendanceSubmenu");
const AttendanceCalendarWrapper = lazyLoad("HRMS/Attendance/MonthlyAttendance/AttendanceCalendarWrapper");
const LeaveApprovalList = lazyLoad("HRMS/Leaves/LeaveApproval/LeaveApprovalList");
const MyLeavesList = lazyLoad("HRMS/Leaves/MyLeaves/MyLeavesList");
const RegularizationList = lazyLoad("HRMS/Attendance/Regularization/RegularizationList");
const CorrectionList = lazyLoad("HRMS/Attendance/Correction/CorrectionList");
const ExtraWorkingApprovalList = lazyLoad("HRMS/Attendance/ExtraWorking/ExtraWorkingApprovalList");
const MyAttendanceRequestList = lazyLoad("HRMS/Attendance/MyAttendanceRequests/MyAttendanceRequestList");

const PayrollSubmenu = lazyLoad("HRMS/Payroll/PayrollSubmenu");
const SalaryComponentCreateEdit = lazyLoad("HRMS/Payroll/SalaryComponent/SalaryComponentCreateEdit");
const SalaryComponentList = lazyLoad("HRMS/Payroll/SalaryComponent/SalaryComponentList");
const SalaryStructureCreateEdit = lazyLoad("HRMS/Payroll/SalaryStructure/SalaryStructureCreateEdit");
const SalaryStructureList = lazyLoad("HRMS/Payroll/SalaryStructure/SalaryStructureList");
const SalaryRevisionCreateEdit = lazyLoad("HRMS/Payroll/SalaryRevisions/SalaryRevisionCreateEdit");
const SalaryRevisionList = lazyLoad("HRMS/Payroll/SalaryRevisions/SalaryRevisionList");
const EmployeeArrearCreateEdit = lazyLoad("HRMS/Payroll/EmployeeArrears/EmployeeArrearCreateEdit");
const EmployeeArrearList = lazyLoad("HRMS/Payroll/EmployeeArrears/EmployeeArrearList");
const EmployeeLoanCreateEdit = lazyLoad("HRMS/Payroll/EmployeeLoans/EmployeeLoanCreateEdit");
const EmployeeLoanList = lazyLoad("HRMS/Payroll/EmployeeLoans/EmployeeLoanList");
const PayrollAdjustmentCreateEdit = lazyLoad("HRMS/Payroll/PayrollAdjustments/PayrollAdjustmentCreateEdit");
const PayrollAdjustmentList = lazyLoad("HRMS/Payroll/PayrollAdjustments/PayrollAdjustmentList");

const TemplateList = lazyLoad("HRMS/HRTools/Templates/TemplateList");
const TemplateCreateEdit = lazyLoad("HRMS/HRTools/Templates/TemplateCreateEdit");
const PayrollApproverList = lazyLoad("HRMS/Payroll/PayrollApprovers/PayrollApproverList");
const PayrollApproverCreateEdit = lazyLoad("HRMS/Payroll/PayrollApprovers/PayrollApproverCreateEdit");
const PayrollRunList = lazyLoad("HRMS/Payroll/EmployeePayroll/PayrollRunList");
const PayrollRunCreateEdit = lazyLoad("HRMS/Payroll/EmployeePayroll/PayrollRunCreateEdit");
const AttendanceHighlightDashboard = lazyLoad("HRMS/Attendance/Highlight/AttendanceHighlightDashboard");
const EmployeePayrollList = lazyLoad("HRMS/Payroll/EmployeeWisePayroll/EmployeePayrollList");
const EmployeePayrollApproval = lazyLoad("HRMS/Payroll/EmployeePayrollApproval/EmployeePayrollApproval");
const OnHoldSalaryList = lazyLoad("HRMS/Payroll/OnHoldSalary/OnHoldSalaryList");

const TypeOfInventory = lazyLoad("Inventory/TypeOfInventory");
const InventoryItems = lazyLoad("Inventory/Items");
const InventoryItemsList = lazyLoad("Inventory/Items/ItemsList");
const InventoryItemCreateEdit = lazyLoad("Inventory/Items/CreateEdit");
const InventoryLocation = lazyLoad("Inventory/Locations");
const InventoryLocationList = lazyLoad("Inventory/Locations/LocationList");
const InventoryLocationCreateEdit = lazyLoad("Inventory/Locations/CreateEdit");
const UserLocationMap = lazyLoad("Inventory/UserLocationMap");
const UserMapList = lazyLoad("Inventory/UserLocationMap/UserMapList");
const UserMapCreateEdit = lazyLoad("Inventory/UserLocationMap/UserMapCreateEdit");
const Transactions = lazyLoad("Inventory/Transactions");
const TransactionList = lazyLoad("Inventory/Transactions/TransactionList");
const TransactionCreateEdit = lazyLoad("Inventory/Transactions/TransactionCreateEdit");
const Stocks = lazyLoad("Inventory/Stocks");
const StockSummaryList = lazyLoad("Inventory/Stocks/StockSummaryList");

/* -------------------------------------------------------------------------- */
/*                       REUSABLE CHILD ROUTE GROUPS                          */
/* -------------------------------------------------------------------------- */

export const userRoutes = [
  { path: "", element: <UserList /> },
  { path: "Create", element: <UserCreateEdit /> },
  { path: "ViewEdit", element: <UserCreateEdit /> },
  { path: "StudentsList", element: <StudentsList /> },
  { path: "MoveStudents", element: <MoveStudents /> },
  { path: "Requests", element: <UserRequestList /> },
  {
    path: "EmployeeProfileCreateEdit/:userid",
    element: <EmployeeProfileCreateEdit />,
  },
  {
    path: "UserPermissions",
    element: <UserPermissions />,
  },
];

export const departmentRoutes = [
  { path: "", element: <DepartmentList /> },
  { path: "Create", element: <DepartmentCreateEdit /> },
  { path: "ViewEdit", element: <DepartmentCreateEdit /> },
];

export const designationRoutes = [
  { path: "", element: <DesignationList /> },
  { path: "Create", element: <DesignationCreateEdit /> },
  { path: "ViewEdit", element: <DesignationCreateEdit /> },
];

export const projectRoutes = [
  { path: "", element: <ProjectList /> },
  { path: "Create", element: <ProjectCreateEdit /> },
  { path: "ViewEdit", element: <ProjectCreateEdit /> },
];

export const instituteRoutes = [
  { path: "", element: <InstituteList /> },
  { path: "Create", element: <InstituteCreateEdit /> },
  { path: "ViewEdit", element: <InstituteCreateEdit /> },
  {
    path: "LeadConvertToCustomer/:instituteid",
    element: <LeadConvertToCustomer />,
  },
  { path: "Filter", element: <InstituteList /> },
];

export const trainingRoutes = [
  { path: "", element: <TrainingList /> },
  { path: "Create", element: <TrainingCreateEdit /> },
  { path: "ViewEdit", element: <TrainingCreateEdit /> },
];

export const scheduleRoutes = [
  { path: "", element: <ScheduleList /> },
  { path: "Create", element: <ScheduleCreateEdit /> },
  { path: "ViewEdit", element: <ScheduleCreateEdit /> },
];

export const activityRoutes = [
  { path: "", element: <SalesList /> },
  { path: "Create", element: <SalesCreateEdit /> },
  { path: "ViewEdit", element: <SalesCreateEdit /> },
];

export const reportRoutes = [
  { path: "", element: <TypeOfReports /> },
  { path: "CrossDateExport", element: <CrossDateExport /> },
  { path: "TrainerAttendance", element: <TrainerAttendance /> },
  { path: "TrainerAttendanceSummary", element: <TrainerAttendanceSummary /> },
  { path: "StudentAttendance", element: <StudentAttendance /> },
  { path: "StudentsDetails", element: <StudentsDetails /> },
  { path: "Student", element: <Student /> },
  { path: "AssessmentReport", element: <AssessmentReport /> },
  { path: "DailyTrainingDocuments", element: <DailyTrainingDocuments /> },
  { path: "TrainingSummary", element: <TrainingSummary /> },
  { path: "TrainingOverviewReport", element: <TrainingOverviewReport /> },
  { path: "FeedbackReport", element: <FeedbackReport /> },
  { path: "InstituteOverview", element: <InstituteOverview /> }
];

export const toolsRoutes = [
  { path: "", element: <TypeOfTools /> },
  {
    path: "Repository",
    element: <Repository />,
    children: [
      { path: "", element: <RepositoryList /> },
      { path: "Create", element: <RepositoryCreateEdit /> },
      { path: "ViewEdit", element: <RepositoryCreateEdit /> },
    ],
  },
  {
    path: "Notes",
    element: <Notes />,
    children: [{ path: "", element: <NoteList /> }],
  },
  {
    path: "AttendanceList",
    element: <AttendanceList />,
  },
];

export const inventoryRoutes = [
  { path: "", element: <TypeOfInventory /> },
  {
    path: "Items",
    element: <InventoryItems />,
    children: [
      { path: "", element: <InventoryItemsList /> },
      { path: "Create", element: <InventoryItemCreateEdit /> },
      { path: "ViewEdit", element: <InventoryItemCreateEdit /> },
    ],
  },
  {
    path: "Locations",
    element: <InventoryLocation />,
    children: [
      { path: "", element: <InventoryLocationList /> },
      { path: "Create", element: <InventoryLocationCreateEdit /> },
      { path: "ViewEdit", element: <InventoryLocationCreateEdit /> },
    ],
  },
  {
    path: "UserLocationMap",
    element: <UserLocationMap />,
    children: [
      { path: "", element: <UserMapList /> },
      { path: "Create", element: <UserMapCreateEdit /> },
      { path: "ViewEdit", element: <UserMapCreateEdit /> },
    ],
  },
  {
    path: "Transactions",
    element: <Transactions />,
    children: [
      { path: "", element: <TransactionList /> },
      { path: "Create", element: <TransactionCreateEdit /> },
      { path: "ViewEdit", element: <TransactionCreateEdit /> },
    ],
  },
  {
    path: "Stocks",
    element: <Stocks />,
    children: [{ path: "", element: <StockSummaryList /> }],
  },
];

export const salesTimelineRoutes = [
  { path: "", element: <SalesFullTimeline /> },
  {
    path: "Filter/:startdate?/:enddate?/:status?/:person?",
    element: <SalesFullTimeline />,
  },
];

export const salesScheduleRoutes = [
  { path: "", element: <SalesScheduleList /> },
  { path: "Create", element: <SalesScheduleCreateEdit /> },
  { path: "ViewEdit", element: <SalesScheduleCreateEdit /> },
];

export const leavesRoutes = [
  {
    path: "",
    element: <LeavesSubmenu />,
  },
  { path: "LeaveType", element: <LeaveTypeList /> },
  { path: "LeaveTypeCreate", element: <LeaveTypeCreateEdit /> },
  { path: "LeaveTypeEdit/:typeid", element: <LeaveTypeCreateEdit /> },
  { path: "LeavePolicySet", element: <LeavePolicySetList /> },
  { path: "LeavePolicySetCreate", element: <LeavePolicySetCreateEdit /> },
  { path: "LeavePolicySetEdit/:setid", element: <LeavePolicySetCreateEdit /> },
  { path: "LeavePolicySetDetail", element: <LeavePolicySetDetailList /> },
  {
    path: "LeavePolicySetDetailCreate",
    element: <LeavePolicySetDetailCreateEdit />,
  },
  {
    path: "LeavePolicySetDetailEdit/:setid",
    element: <LeavePolicySetDetailCreateEdit />,
  },
  { path: "Holiday", element: <HolidayList /> },
  { path: "HolidayCreate", element: <HolidayCreate /> },
  { path: "Adjustment", element: <LeaveLedgerList /> },
  { path: "AdjustmentCreate", element: <AdjustmentCreate /> },
  { path: "LeaveApproval", element: <LeaveApprovalList /> },
  { path: "MyLeaves", element: <MyLeavesList /> },
];

export const hrToolsRoutes = [
  {
    path: "",
    element: <HRToolsSubmenu />,
  },
  { path: "WorkCalendar", element: <WorkCalendarList /> },
  { path: "WorkCalendarCreate", element: <WorkCalendarCreateEdit /> },
  { path: "WorkCalendarEdit/:id", element: <WorkCalendarCreateEdit /> },
  { path: "ShiftTemplate", element: <ShiftTemplateList /> },
  { path: "ShiftTemplateCreate", element: <ShiftTemplateCreateEdit /> },
  { path: "ShiftTemplateEdit/:id", element: <ShiftTemplateCreateEdit /> },
  { path: "EmployerBankAccount", element: <EmployerBankAccountList /> },
  {
    path: "EmployerBankAccountCreate",
    element: <EmployerBankAccountCreateEdit />,
  },
  {
    path: "EmployerBankAccountEdit/:id",
    element: <EmployerBankAccountCreateEdit />,
  },
  { path: "AssignedPolicy", element: <AssignedPolicyList /> },
  { path: "AssignedPolicyCreate", element: <AssignedPolicyCreateEdit /> },
  { path: "AssignedPolicyEdit/:id", element: <AssignedPolicyCreateEdit /> },
  { path: "PolicyDocument", element: <PolicyDocumentList /> },
  { path: "PolicyDocumentCreate", element: <PolicyDocumentCreateEdit /> },
  { path: "PolicyDocumentEdit/:id", element: <PolicyDocumentCreateEdit /> },
  { path: "Template", element: <TemplateList /> },
  { path: "TemplateCreate", element: <TemplateCreateEdit /> },
  { path: "TemplateEdit/:id", element: <TemplateCreateEdit /> },
];

export const documentRoutes = [
  { path: "", element: <DocumentsSubmenu /> },
  { path: "SalarySlips", element: <DocumentList type="salary-slip" /> },
  { path: "HRDocuments", element: <DocumentList type="hr-document" /> },
];

export const attendanceRoutes = [
  { path: "", element: <AttendanceSubmenu /> },
  { path: "MonthlyAttendance", element: <AttendanceCalendarWrapper /> },
  { path: "RegularizationList", element: <RegularizationList /> },
  { path: "CorrectionList", element: <CorrectionList /> },
  { path: "ExtraWorkingApproval", element: <ExtraWorkingApprovalList /> },
  {
    path: "MyRegularization",
    element: <MyAttendanceRequestList category="regularization" />,
  },
  {
    path: "MyCorrection",
    element: <MyAttendanceRequestList category="correction" />,
  },
  {
    path: "MyExtraWorking",
    element: <MyAttendanceRequestList category="comp_off" />,
  },
  {
    path: "AttendanceHighlightDashboard",
    element: <AttendanceHighlightDashboard />,
  },
  {
    path: "AttendanceHighlightModifications/:userid/:empid/:date/:type",
    element: <AttendanceCalendarWrapper />,
  },
];

export const payrollRoutes = [
  { path: "", element: <PayrollSubmenu /> },
  { path: "SalaryComponentCreate", element: <SalaryComponentCreateEdit /> },
  { path: "SalaryComponentEdit/:id", element: <SalaryComponentCreateEdit /> },
  { path: "SalaryComponentList", element: <SalaryComponentList /> },
  { path: "SalaryStructureCreate", element: <SalaryStructureCreateEdit /> },
  { path: "SalaryStructureEdit/:id", element: <SalaryStructureCreateEdit /> },
  { path: "SalaryStructureList", element: <SalaryStructureList /> },
  { path: "SalaryRevisionCreate", element: <SalaryRevisionCreateEdit /> },
  { path: "SalaryRevisionEdit/:id", element: <SalaryRevisionCreateEdit /> },
  { path: "SalaryRevisionList", element: <SalaryRevisionList /> },
  { path: "EmployeeArrearCreate", element: <EmployeeArrearCreateEdit /> },
  { path: "EmployeeArrearEdit/:id", element: <EmployeeArrearCreateEdit /> },
  { path: "EmployeeArrearList", element: <EmployeeArrearList /> },
  { path: "EmployeeLoanCreate", element: <EmployeeLoanCreateEdit /> },
  { path: "EmployeeLoanEdit/:id", element: <EmployeeLoanCreateEdit /> },
  { path: "EmployeeLoanList", element: <EmployeeLoanList /> },
  { path: "PayrollAdjustmentCreate", element: <PayrollAdjustmentCreateEdit /> },
  {
    path: "PayrollAdjustmentEdit/:id",
    element: <PayrollAdjustmentCreateEdit />,
  },
  { path: "PayrollAdjustmentList", element: <PayrollAdjustmentList /> },
  { path: "PayrollApproverCreate", element: <PayrollApproverCreateEdit /> },
  { path: "PayrollApproverEdit/:id", element: <PayrollApproverCreateEdit /> },
  { path: "PayrollApproverList", element: <PayrollApproverList /> },
  { path: "PayrollRunCreate", element: <PayrollRunCreateEdit /> },
  { path: "PayrollRunEdit/:id", element: <PayrollRunCreateEdit /> },
  { path: "PayrollRunList", element: <PayrollRunList /> },
  { path: "EmployeePayrollList", element: <EmployeePayrollList /> },
  { path: "EmployeePayrollApproval", element: <EmployeePayrollApproval /> },
  { path: "OnHoldSalaryList", element: <OnHoldSalaryList /> },
];
